export const PersionView = ({
  secondaryColor = "#3b4046",

  primaryFontColor = "rgb(255, 255, 255)",
  width ,
  height ,
}) => {
  return (
    <svg id="Group_45410" data-name="Group 45410" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32">
      <circle id="Ellipse_1413" data-name="Ellipse 1413" cx="16" cy="16" r="16" fill={secondaryColor} />
      <g id="Group_45409" data-name="Group 45409" transform="translate(10.857 10.148)">
        <g id="Group_45335" data-name="Group 45335" transform="translate(2.057)">
          <g id="Group_45334" data-name="Group 45334">
            <path id="Path_65970" data-name="Path 65970" d="M124.086,0a3.086,3.086,0,1,0,3.086,3.086A3.089,3.089,0,0,0,124.086,0Z" transform="translate(-121)" fill="#fff" />
          </g>
        </g>
        <g id="Group_45337" data-name="Group 45337" transform="translate(0 6.857)">
          <g id="Group_45336" data-name="Group 45336">
            <path id="Path_65971" data-name="Path 65971" d="M39.982,301.33A4.4,4.4,0,0,0,36.829,300H35.457a4.4,4.4,0,0,0-3.154,1.33A4.5,4.5,0,0,0,31,304.5a.343.343,0,0,0,.343.343h9.6a.343.343,0,0,0,.343-.343A4.5,4.5,0,0,0,39.982,301.33Z" transform="translate(-31 -300)" fill="#fff" />
          </g>
        </g>
      </g>
    </svg>

  );
};
